import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
const testimonials = [{
  quote: 'Organicé todo el año en una tarde. Ahora tengo cada clase pensada y secuenciada para todos mis grupos. Nunca más el domingo de pánico antes de la semana.',
  name: 'Sofía M.',
  location: 'Buenos Aires',
  role: 'Profe de Yoga en Estudio Propio'
}, {
  quote: 'Las secuencias con progresión real por nivel cambiaron todo. Mis alumnas avanzaron más en 2 meses que en todo el año anterior. Y dejaron de irse.',
  name: 'Carolina R.',
  location: 'Rosario',
  role: 'Profe de Yoga en Centro de Bienestar'
}, {
  quote: 'Adapto la misma postura a 3 niveles distintos en 5 minutos. Antes me llevaba horas pensar qué hacer con un grupo heterogéneo. Ahora abro el PDF y está todo.',
  name: 'Valentina F.',
  location: 'Córdoba',
  role: 'Profe de Yoga Grupal e Individual'
}];
export function TestimonialsHero() {
  return <section className="py-10 md:py-20 bg-yoga-purple-50" data-id="element-297">
      <div className="container mx-auto px-4" data-id="element-298">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-299">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-white rounded-xl md:rounded-2xl p-5 md:p-8 shadow-lg border border-yoga-purple-100 relative" data-id="element-300">
              <Quote className="absolute top-4 right-4 md:top-6 md:right-6 text-yoga-purple-100 w-8 h-8 md:w-12 md:h-12 rotate-180" data-id="element-301" />
              <div className="flex gap-1 mb-3 md:mb-6" data-id="element-302">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yoga-gold text-yoga-gold" data-id="element-303" />)}
              </div>
              <p className="text-gray-700 italic mb-4 md:mb-8 relative z-10 leading-relaxed text-sm md:text-base" data-id="element-304">
                "{testimonial.quote}"
              </p>
              <div className="mt-auto" data-id="element-305">
                <p className="font-bold text-yoga-purple-900 text-sm" data-id="element-306">
                  {testimonial.name}
                </p>
                <p className="text-xs md:text-sm text-yoga-purple-600 font-medium" data-id="element-307">
                  {testimonial.location}
                </p>
                <p className="text-xs text-gray-500 mt-0.5" data-id="element-308">
                  {testimonial.role}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}